import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fuelCalculationAppliesOnAdapter = getAdapter({ idFieldName: 'value' });

const fuelCalculationAppliesOnSlice = createSlice({
  name: 'fuelCalculationAppliesOn',
  initialState: fuelCalculationAppliesOnAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setFuelCalculationAppliesOn: (state, { payload: { fuelCalculationAppliesOn } }) => {
      fuelCalculationAppliesOnAdapter.setAll(state, fuelCalculationAppliesOn);
    }
  }
});

const selectors = fuelCalculationAppliesOnAdapter.getSelectors(({ fuelCalculationAppliesOn }) => fuelCalculationAppliesOn);

export const getFuelCalculationAppliesOn = state => selectors.selectAll(state);

export const { setFuelCalculationAppliesOn } = fuelCalculationAppliesOnSlice.actions;

export default fuelCalculationAppliesOnSlice.reducer;
